
import { defineComponent } from "vue";
import PublicPage from "@/views/public/PublicPage.vue";

export default defineComponent({
  name: "privacy-page",
  components: { PublicPage },
});
